import ProductJp from './ProductJp';
import { PageComUPSAU } from '@elem/compPage/river-3-series-portable-power-station/detail/NewProductContent.tsx';
import css from './ProductContent.module.scss';

export default function Teaser({ bundles, callbackCart }: any) {
    return (
        <div className={css.R3Page}>
            <PageComUPSAU />
        </div>
    );
}
